// Wrappers over window.location so callers can be unit-tested (jsdom's
// window.location is not configurable, so it cannot be spied on directly).

export function reloadPage() {
  window.location.reload();
}

export function navigateTo(url: string) {
  window.location.assign(url);
}
